<template>
  <div class="contact-picker">
    <van-popup v-model="visible" position="bottom" style="top:100px;">
      <van-contact-list
        v-model="value"
        add-text="新建就诊人"
        :list="list"
        @add="onAdd"
        @edit="onEdit"
        @select="onSelect"
      />
    </van-popup>
  </div>
</template>

<script>
import { Popup, ContactList } from "vant";
import { jump, cache } from "@/utils/common";
export default {
  name: "ContactPicker",
  components: {
    [Popup.name]: Popup,
    [ContactList.name]: ContactList
  },
  props: {
    value: {
      type: [String, Number],
      default: "text"
    },
    change: { type: Function }
  },
  data() {
    return {
      visible: false,
      isShow: true,
      list: []
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.visible = true;
  },

  methods: {
    init() {
      this.$post("Contact_List").then(res => {
        const list = res.data.datas;
        this.list = list.map(item => {
          // item.id = item.id;
          item.name = item.cardholderName;
          item.tel = "就诊卡号：" + item.cardNo;
          return item;
        });
      });
    },
    cancel() {
      this.visible = false;
      this.$emit("destroy");
    },
    onAdd() {
      this.cancel();
      jump("userContactEdit");
    },
    onEdit(item) {
      this.cancel();
      jump("userContactEdit", {
        Id: item.id
      });
    },
    onSelect(data) {
      if (this.isShow) {
        cache.set("currentContact", data, 24 * 60 * 60 * 1000);
        this.$emit("change", data);
        this.cancel();
        this.isShow = false;
      }
    }
  }
};
</script>

<style lang="less"></style>
